export const environment = {
  production: false,
  envType: 'DEVELOPMENT',
  isFullOnline: true,
  caisseApiUrl: 'https://devgestion.quiditmiam.fr/api',
  title: 'Caisse Collective - Développement',
  buildDate: "2026-10-05T10:04:57",
  lastPipeline: "6669",
  version: "0.0.0",
  sentryDsn: '',
};
